/**
 * GIF search consent — SPEC §19 (user control, opt-in by default).
 * Enabling this only affects *online* GIF search via the same-origin proxy.
 * Local GIF/sticker import needs no consent and is always available.
 */

export interface GifPrefs {
  /** Online GIF search via Veto proxy (Tenor). Default off — explicit opt-in. */
  onlineSearchEnabled: boolean;
}

const KEY = "veto.gif.prefs";

export function loadGifPrefs(): GifPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { onlineSearchEnabled: false };
    const parsed = JSON.parse(raw) as Partial<GifPrefs>;
    return { onlineSearchEnabled: parsed.onlineSearchEnabled === true };
  } catch {
    return { onlineSearchEnabled: false };
  }
}

export function saveGifPrefs(prefs: GifPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    /* storage unavailable — search stays off */
  }
}
